import { Space } from 'component/Space'
import { Icon } from 'icon/Icon'
import css from 'page/CombineScreen/item/SelectedBadge.module.scss'
import { RefObject, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  anchorRef: RefObject<HTMLElement>
}

export const SelectedBadge = ({ anchorRef }: Props) => {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null)

  useLayoutEffect(() => {
    const update = () => {
      const el = anchorRef.current
      if (!el) return
      const rect = el.getBoundingClientRect()
      setPos({ top: rect.top - 8, left: rect.right - 16 })
    }

    update()
    window.addEventListener('scroll', update, true)
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('scroll', update, true)
      window.removeEventListener('resize', update)
    }
  }, [anchorRef])

  if (!pos) return null

  return createPortal(
    <Space center className={css.badge} style={{ top: pos.top, left: pos.left }}>
      <Icon name="check" size={12} />
    </Space>,
    document.body
  )
}
